"use client";

import { Box, Columns, Row, Text } from "@dxp-feed/ui";
import React from "react";

const NearbyStoreSkeleton: React.FC = () => {
  return (
    <Box>
      <Text
        as="h2"
        className="font-sans lgs:text-2xl text-xl lgs:pb-6 pb-4 font-extrabold"
      >
        Nearby Stores
      </Text>
      <Row>
        <Box className="overflow-x-scroll pb-12 p-2">
          <Columns className="col-12 flex md:w-[1196px] w-[1296px] md:gap-6 gap-2 xl:mb-0 mb-4 nearstore">
            {[1, 2, 3].map((_, index) => (
              <Box
                key={index}
                className="lgs:w-[382px] relative md:w-[357px] xs:w-[432px] w-[350px] rounded-2xl shadow-[0px_0px_4px_rgba(0,0,0,0.25)] p-6 animate-pulse bg-gray-100"
              >
                <Box className="flex h-full flex-col justify-between">
                  <Box className="flex-1">
                    <Box className="h-6 w-3/4 bg-gray-300 rounded mb-6" />
                    <Box className="flex items-center gap-2 mb-4">
                      <Box className="w-6 h-6 bg-gray-300 rounded-full" />
                      <Box className="h-4 w-1/2 bg-gray-300 rounded" />
                    </Box>
                    <Box className="flex items-start gap-2 mb-4">
                      <Box className="w-6 h-6 bg-gray-300 rounded-full" />
                      <Box className="h-4 w-5/6 bg-gray-300 rounded" />
                    </Box>
                    <Box className="flex items-center gap-2 mb-4">
                      <Box className="w-6 h-6 bg-gray-300 rounded-full" />
                      <Box className="h-4 w-1/2 bg-gray-300 rounded" />
                    </Box>
                  </Box>
                  <Box className="xs:flex justify-between xs:gap-4 items-center pt-4 border-t border-[#DCDCDC]">
                    <Box className="h-10 w-full xs:w-1/2 bg-gray-300 rounded mb-3 xs:mb-0" />
                    <Box className="h-10 w-full xs:w-1/2 bg-gray-300 rounded" />
                  </Box>
                </Box>
              </Box>
            ))}
          </Columns>
        </Box>
      </Row>
    </Box>
  );
};

export default NearbyStoreSkeleton;
